export const ALERT_BROADCAST_CHANNEL_TIMEOUT = 1000;
export const ALERT_MANAGER_EVENT_CLEAR_BANNER = 'clearBanner';
export const ALERT_MANAGER_EVENT_CLEAR_MODAL = 'clearModal';
export const ALERT_MANAGER_EVENT_DISPLAY_MODAL = 'displayModal';
export const ALERT_MANAGER_EVENT_DISPLAY_MODAL_WITH_PROMISE = 'displayModalWithPromise';
export const ALERT_MANAGER_EVENT_DISPLAY_BANNER = 'displayBanner';
export const ALERT_MANAGER_EVENT_DISPLAY_LOCAL_TOAST = 'displayLocalToast';
export const ALERT_MANAGER_EVENT_DISPLAY_TOAST = 'displayToast';
export const ALERT_MANAGER_EVENTS = Object.freeze([
  ALERT_MANAGER_EVENT_CLEAR_BANNER,
  ALERT_MANAGER_EVENT_CLEAR_MODAL,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL_WITH_PROMISE,
  ALERT_MANAGER_EVENT_DISPLAY_BANNER,
  ALERT_MANAGER_EVENT_DISPLAY_LOCAL_TOAST,
  ALERT_MANAGER_EVENT_DISPLAY_TOAST,
]);
export const ALERT_MANAGER_EVENT_TYPE_BANNER = 'banner';
export const ALERT_MANAGER_EVENT_TYPE_LOCAL_TOAST = 'localToast';
export const ALERT_MANAGER_EVENT_TYPE_MODAL = 'modal';
export const ALERT_MANAGER_EVENT_TYPE_MODAL_WITH_PROMISE = 'modalWithPromise';
export const ALERT_MANAGER_EVENT_TYPE_TOAST = 'toast';
export const INSTANCE_DEFAULT = 'global';

export default {
  ALERT_BROADCAST_CHANNEL_TIMEOUT,
  ALERT_MANAGER_EVENT_CLEAR_BANNER,
  ALERT_MANAGER_EVENT_CLEAR_MODAL,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL,
  ALERT_MANAGER_EVENT_DISPLAY_MODAL_WITH_PROMISE,
  ALERT_MANAGER_EVENT_DISPLAY_BANNER,
  ALERT_MANAGER_EVENT_DISPLAY_LOCAL_TOAST,
  ALERT_MANAGER_EVENT_DISPLAY_TOAST,
  ALERT_MANAGER_EVENTS,
  ALERT_MANAGER_EVENT_TYPE_BANNER,
  ALERT_MANAGER_EVENT_TYPE_LOCAL_TOAST,
  ALERT_MANAGER_EVENT_TYPE_MODAL,
  ALERT_MANAGER_EVENT_TYPE_MODAL_WITH_PROMISE,
  ALERT_MANAGER_EVENT_TYPE_TOAST,
  INSTANCE_DEFAULT,
};
